import { createAsyncThunk } from "@reduxjs/toolkit";
import { appName, chargebeeUrl } from "../../constants/defaultValues"

import axiosChargebee from "../utils/chargebee";

import {
  notification
} from "../actions";

export const getPlan = createAsyncThunk("getPlan", async (payload, thunkAPI) => {
  try {
    const response = await axiosChargebee.get(`/v1/subscriptions/${payload}`);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const getAddons = createAsyncThunk("getAddons", async (payload, thunkAPI) => {
  try {
    const response = await axiosChargebee.get(`/v1/add-on?period_unit=${payload.period}&currency_code=${payload.currency}`);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})